import { Component } from '@angular/core';
import { GeneralEmitterService } from '../../services/general-emitter.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
export class SpinnerComponent {
  showSpinner = false;
  constructor(
    private emitterData: GeneralEmitterService
  ) { }

  ngOnInit(): void {
    this.subscription()
  }

  subscription() {
    this.emitterData.showSpinner.subscribe((res: any) => {
      this.showSpinner = res;
    });
  }




}
